import React from 'react';
import {BooleanInput, Edit, SimpleForm, TextInput} from 'react-admin';

const DiseaseEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="show">
                <BooleanInput source="deleted" />
                <TextInput source="name" />
            </SimpleForm>
        </Edit>
    );
};

export default DiseaseEdit;